import { Component, OnInit } from '@angular/core';


import { DomSanitizer } from '@angular/platform-browser';

import { ActivatedRoute } from '@angular/router';

import { AccountService } from 'src/app/services/account.service';

import { OtherService } from 'src/app/services/other.service';

@Component({

  selector: 'app-education',

  templateUrl: './education.component.html',

  styleUrls: ['./education.component.css']

})

export class EducationComponent implements OnInit {

  Info: any;

  lst_Educations: any = [];

  lst_Search: any = [];

  bDetail: boolean = false;

  constructor(

    private accountService: AccountService,

    private otherService: OtherService,

    private sanitizer: DomSanitizer,

    private route: ActivatedRoute

  ) { }

  ngOnInit(): void {

    this.route.paramMap.subscribe((params: any) => {

      if (params.get('id')) {

        this.bDetail = true;

        this.otherService.setTitle('تاکسی لون | محتواهای آموزشی تاکسی بین شهری ');

        this.accountService.Educational_Info(params.get('id')).subscribe((data: any) => {

          let res = JSON.parse(data.toString())

          res.forEach((el: any, index: number) => {

            res[index].strContentPath = this.return_SafeUrl(el.strContentPath);

          })

          this.lst_Educations.push(res[0])


        })

      }

      else {

        this.Info = this.otherService.getLocalStorage();

        this.otherService.setTitle('تاکسی لون | محتواهای آموزشی تاکسی بین شهری ');

        this.accountService.Educational_List().subscribe((data: any) => {

          let res = JSON.parse(data.toString())

          res.forEach((el: any, index: number) => {

            res[index].strContentPath = this.return_SafeUrl(el.strContentPath);

          })

          this.lst_Educations = res;

          this.lst_Search = res;


        });

      }

    })

  }

  return_SafeUrl(url: string) {
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }

  subString_Title(text: string, limit?: number) {

    if (limit && text?.length > limit) text = text.slice(0, limit) + '...';

    if (!limit && text?.length > 55) text = text.slice(0, 55) + '...';


    return text;
  }

  openEducation(item) {

    window.open(`/taxilon/education/${item.iEducationalContent}`, '_blank')

  }

  search_Educations(strValue) {

    if (strValue.length > 1) {

      this.lst_Educations = this.lst_Search.filter((el: any) => {

        return el.strTitle.includes(strValue)

      })

    }

    else if (strValue == '') this.lst_Educations = this.lst_Search;

  }


}
